const n = {
  name: "Minus",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 11H20V13H4V11Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Minus
};
